import { OktaAuth } from "@okta/okta-auth-js";
import { getEnv } from "@/env";

const issuer = getEnv("VUE_APP_OKTA_ORG_URL");
const clientId = getEnv("VUE_APP_OKTA_CLIENT_ID");
const redirectUri = getEnv("VUE_APP_OKTA_REDIRECT_URL");

const oktaAuth = new OktaAuth({
  issuer,
  clientId,
  redirectUri,
  scopes: ["openid", "profile", "email", "groups"],
  pcke: true,
});

export default oktaAuth;
